<template>
  <!-- 详情 -->
  <div class="Uploadpagem">
    <el-form
      :inline="true"
      :model="tepslat"
      :rules="rules"
      ref="tepslat"
      class="demo-form-inline"
    >
      <el-dialog
        class="dialogbhuyuan"
        :title="btiskk"
        :visible.sync="dialogVisiblebh"
        width="50%"
      >
        <p>{{ bhyys }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblebh = false">取 消</el-button>
        </span>
      </el-dialog>
      <ul>
        <li class="Draftbox">
          <div class="Draftbox_top">
            <div style="cursor: pointer" @click="fanhui()">返回</div>
            <p style="cursor: pointer">
              状态：
              <span v-if="tepslat.status === '已发布'" style="color: #04ac10">
                已通过</span
              >
              <span
                v-if="tepslat.status === '已驳回'"
                @click="dialogVisiblebhss(tepslat, '已驳回')"
                style="color: #fb4747"
              >
                {{ tepslat.status }}(查看)</span
              >
              <span
                v-if="tepslat.status === '已撤回'"
                @click="dialogVisiblebhss(tepslat, '已撤回')"
                style="color: #fb4747"
              >
                {{ tepslat.status }}(查看)</span
              >
              <span v-if="tepslat.status === '已保存'">
                {{ tepslat.status }}</span
              >
              <span v-if="tepslat.status === '待审核'" style="color: #4ccaff">
                审批中</span
              >
            </p>
          </div>

          <div class="Draftbox_left">
            <div class="Draftbox_left_top">
              <div class="certer">
                <el-form-item label="科普标题" size="mini" prop="name">
                  <el-input
                    :disabled="tepslat.tid !== null"
                    v-model="tepslat.name"
                    placeholder="请输入科普标题"
                  ></el-input>
                </el-form-item>

                <el-form-item label="科普分类" size="mini" prop="sort">
                  <el-select
                    :disabled="tepslat.tid !== null"
                    v-model="tepslat.sort"
                    placeholder="请选择科普类型"
                  >
                    <el-option
                      v-for="item in Majorcategories"
                      :key="item.id"
                      :label="item.sort"
                      :value="item.sort"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="Draftbox_rist">
                <video
                  v-if="tepslat.sorts == '视频'"
                  :src="http + tepslat.video"
                  controls
                  style="
                    width: 181px;
                    height: 110px;
                    opacity: 0.8;
                    border-radius: 6px;
                  "
                ></video>
                <el-upload
                  v-if="tepslat.sorts == '视频'"
                  :disabled="
                    tepslat.status === '已发布' || tepslat.status === '待审核'
                  "
                  class="uploader1"
                  action="1"
                  :show-file-list="false"
                  :on-change="
                    (file, fileList) => {
                      beforeAvatarUpload(file, fileList);
                    }
                  "
                >
                  <img
                    :src="
                      tepslat.picture !== null ? tepslat.picture : commonImg
                    "
                    style="width: 181px; height: 105px"
                    class="avatar"
                  />
                  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->

                  <img
                    class="delista"
                    style="width: 20px; height: 20px"
                    src="../../../assets/delites.jpg"
                    alt=""
                  />
                </el-upload>
                <!-- <el-button class="lasez" type="primary" @click="submitForm(item)"
                >更换视频</el-button
              > -->
              </div>
            </div>
            <div class="Draftbox_left_bottonm">
              <el-form-item label="课程概述" size="mini" prop="kcjs">
                <wangEnduitcopy
                  :isClear="isClear"
                  @blur="question"
                  @change="change"
                  :value="tepslat.content"
                ></wangEnduitcopy>
                <!-- <el-input
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 5 }"
                  v-model="tepslat.kcjs"
                  placeholder="请输入文件标题"
                ></el-input> -->
              </el-form-item>
            </div>
          </div>

          <div class="right-bottom">
            <!-- <el-button class="sch" type="danger" @click="delmaterial(item)"
              >删除</el-button
            > -->
            <el-button
              v-show="
                tepslat.status !== '已发布' && tepslat.status !== '待发布'
              "
              class="lasez"
              type="primary"
              @click="submitForm('tepslat')"
              >保存</el-button
            >
            <el-button
              class="lasez"
              type="primary"
              @click="Fileupload(tepslat)"
              v-show="
                tepslat.status === '已保存' ||
                tepslat.status === '已驳回' ||
                tepslat.status === '已撤回'
              "
              >提交科普</el-button
            >
          </div>
        </li>
      </ul>
    </el-form>
  </div>
</template>
<script>
import { selsortMu, selknow, updknow, updatetaskuser } from "@/api/patient";
import wangEnduitcopy from "../../../components/wangEnduitcopy.vue";
export default {
  data() {
    return {
      isClear: false,
      btiskk: "",
      dialogVisiblebh: false,
      bhyys: "",
      tepage: {
        page: 1,
        rows: 3,
        total: 100,
      },
      tepslat: {},
      http: this.$store.state.https,
      Thepicture: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      imageUrl: "",
      formInline: {
        region: "",
        user: "",
        regiosnss: "",
      },
      width: "21321",
      height: "",
      Majorcategories: [],
      id: this.$store.state.user.id,
      rules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        sort: [{ required: true, message: "请选择分类", trigger: "blur" }],
        // kcjs: [{ required: true, message: "请输入课程概述", trigger: "blur" }],
        xxmb: [{ required: true, message: "请填写学习目标", trigger: "blur" }],

        // region: [
        //   { required: true, message: '请填写活动形式', trigger: 'blur' }
        // ],
        // regiosnss: [
        //   { required: true, message: '请输入活动名称', trigger: 'blur' }
        // ]
      },
      commonImg: require("../../../assets/common/jkkp.png"),
    };
  },
  created() {
    // this.id = this.$store.state.user.

    this.selmaterialis();
    this.selsortis();
  },
  methods: {
    fanhui() {
      this.$router.push("/Materialtoupload");
    },
    beforeAvatarUpload(file, fileList) {
      var a = false;
      console.log(file);
      const isJPG =
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      console.log(isJPG, isLt2M);
      if (isJPG == false || isLt2M == false) {
        this.$message.error("封面图只能是 JPG,PNG 格式!封面图大小不得超过2MB!");
      } else {
        this.tepslat.picture = URL.createObjectURL(file.raw);
        a = true;
      }
      if (a) {
        this.tepslat.picturefile = file.raw;
      }
      console.log(this.tepslat);
    },
    // 筛选大类
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("name", "知识科普");
      selsortMu(data).then((res) => {
        this.Majorcategories = res;
      });
    },
    change(val) {
      console.log(val);
      this.tepslat.kcjs = val;
    },
    question() {
      // validateField表单的字段验证的方法
      this.$refs.tepslat.validateField("kcjs");
    },

    async Fileupload(item) {
      console.log(item);
      var data = new FormData();
      if (item.sorts == "文章") {
        var imageRegex = /(https?:\/\/.*?\.(?:jpg|jpeg|png|gif)(?:\?.*)?)/gi;
        var match = imageRegex.exec(this.tepslat.kcjs);
        if (match !== null) {
          data.append("picture", match[0]);
        }
      } else {
        if (
          this.tepslat.picturefile !== "" &&
          this.tepslat.picturefile !== null
        ) {
          data.append("picturefile", this.tepslat.picturefile);
        }
      }
      data.append("phone", this.$store.state.user.phone);
      data.append("name", this.tepslat.name);
      if (this.tepslat.kcjs) {
        data.append("content", this.tepslat.kcjs);
      }
      data.append("cause", "");
      data.append("sort", this.tepslat.sort);
      data.append("status", "待审核");
      data.append("id", item.id);
      updknow(data).then((res) => {
        if (res.code == "OK") {
          var data1 = new FormData();
          data1.append("tid", item.tid);
          data1.append("phone", item.phone);
          data1.append("status", "已提交");
          updatetaskuser(data1).then((res) => {
            console.log(res);
          });
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: "提交失败",
            type: "error",
          });
        }
      });
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (
          //   this.tepslat.kcjs == "" ||
          //   this.tepslat.kcjs == null ||
          //   this.tepslat.kcjs == undefined
          // )
          //   return this.$message({
          //     message: "请填写完整",
          //     type: "warning",
          //   });
          var data = new FormData();
          if (this.tepslat.sorts == "文章") {
            var imageRegex =
              /(https?:\/\/.*?\.(?:jpg|jpeg|png|gif)(?:\?.*)?)/gi;
            var match = imageRegex.exec(this.tepslat.kcjs);
            if (match !== null) {
              data.append("picture", match[0]);
            }
          } else {
            if (
              this.tepslat.picturefile !== "" &&
              this.tepslat.picturefile !== null
            ) {
              data.append("picturefile", this.tepslat.picturefile);
            }
          }
          data.append("phone", this.$store.state.user.phone);
          data.append("name", this.tepslat.name);
          if (
            this.tepslat.kcjs == "" ||
            this.tepslat.kcjs == null ||
            this.tepslat.kcjs == undefined
          ) {
            data.append("content", this.tepslat.content);
          } else {
            data.append("content", this.tepslat.kcjs);
          }
          data.append("sort", this.tepslat.sort);
          data.append("status", "已保存");
          data.append("id", this.$route.params.id);
          updknow(data).then((res) => {
            if (res.code == "OK") {
              this.$message({
                showClose: true,
                message: "保存成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: "保存失败",
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    dialogVisiblebhss(item, i) {
      if (i === "已驳回") {
        this.btiskk = "驳回原因";
      } else {
        this.btiskk = "撤回原因";
      }

      this.dialogVisiblebh = true;
      this.bhyys = item.cause;
    },
    selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("id", this.$route.params.id);
      selknow(data).then((res) => {
        console.log(typeof this.tepslat);
        // console.log(res);
        this.tepslat = res;
        if (this.tepslat.picture !== "" && this.tepslat.picture !== null) {
          this.tepslat.picture = this.$store.state.https + this.tepslat.picture;
        }
      });
    },
  },
  components: {
    wangEnduitcopy,
  },
};

// function fileChoosed (event) {
//   console.log('aa')
//   const file = event.target.files[0]
//   const fileName = file.name
//   const img = document.getElementById('a')
//   const fr = new FileReader()
//   // const ts = this
//   fr.addEventListener('load', () => {
//     const blob = 'a'
//     console.log(fileName, img, blob) // 这里能获取到三个变量
//     img.onload = () => { // 不建议在浏览器里直接用箭头函数，支持不好
//       debugger
//       console.log(fileName, img, blob)
//       //  经过测试是可以打印这三个变量的
//     }
//     img.src = fr.result
//   })
//   fr.readAsDataURL(file)
// }
</script>
<style lang="scss" scoped>
.Uploadpagem {
  width: 100%;
  background: #ffffff;

  margin-top: 4px;
  box-shadow: 0px 0px 3px 4px rgba(6, 0, 1, 0.07);
  .box {
    width: 1090px;
    min-height: 1200px;
    text-align: left;
    margin: 0 auto;
    padding-top: 20px;
  }
}
.Draftbox {
  flex-direction: column;
  display: flex;
  width: 772px;
  background: #ffffff;
  border: 1px solid #ededed;
  //   line-height: 190px;

  img {
    width: 246px;
    height: 150px;
    opacity: 0.8;
    border-radius: 6px;
  }
  .Draftbox_left {
    margin-top: 20px;
    width: 100%;
    height: 100%;
    .Draftbox_left_top {
      margin-bottom: 30px;
      display: flex;

      .certer {
        text-align-last: left;
        margin-left: 20px;
        width: 40%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        ::v-deep .el-form-item {
          .el-form-item__label {
            width: 70px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            line-height: 34px;
          }
          .el-form-item__content {
            width: 200px;
            .el-select {
              width: 100%;
            }
            .el-input {
              width: 100%;
            }
            .el-textarea {
              width: 100%;
            }
          }
        }
      }
      .Draftbox_rist {
        padding-top: 10px;
        width: 55%;

        display: flex;
        justify-content: space-around;
        p {
          margin-top: 10px;
          height: 16px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
        .lasez {
          margin-top: 32px;
          padding: 0;
          width: 99px;
          height: 28px;
          border-radius: 6px;
          border: 0;
          background: #4ccaff;
        }
        .lasez:hover {
          background: #4ccaffc9;
        }
      }
    }
    .Draftbox_left_bottonm {
      margin-left: 0px;
      ::v-deep.el-form-item {
        display: flex;
        .el-form-item__label {
          width: 96px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 34px;
        }
        .el-form-item__content {
          text-align-last: left;
          width: 80%;
          .el-select {
            width: 100%;
          }
          .el-input {
            width: 100%;
          }
          .el-textarea {
            width: 100%;
          }
        }
      }
    }
  }

  .right-bottom {
    height: 100%;
    margin-top: 10px;
    margin-bottom: 100px;
    display: flex;
    justify-content: center;
    margin-left: 50px;
    // flex-direction: column;
    button {
      //   margin: 0px;
      padding: 0;
      width: 99px;
      height: 28px;
      border-radius: 6px;
      border: 0;
    }
    .lasez {
      background: #4ccaff;
    }
    .lasez:hover {
      background: #4ccaffc9;
    }
    .sch:hover {
      background: #f56c6cc7;
    }
  }
}
ul {
}

.el-button:hover {
  background: #4ccaffc9;
}
.gos {
  padding: 27px;
  font-size: 37px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  color: #4ccaff;
}
.sctsd {
  margin-top: 76px;
  margin-bottom: 20px;
}
.ssra3 {
  font-size: 12px;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
.Draftbox_top {
  margin-top: 20px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}
::v-deep.uploader1 {
  width: 181px;
  height: 105px;
  background: #f6f6f6;
  border-radius: 10px;
  .el-upload {
    text-align: center;
    width: 181px;
    height: 105px;
    .el-icon-plus {
      text-align: center;
      width: 181px;
      height: 105px;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 181px;
      height: 105px;
      line-height: 105px;
    }
    .delista {
      position: relative;
      top: -113px;
      right: -90px;
      z-index: 100;
    }
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Uploadpagem {
    .box {
      width: 100vw;
      .box-ceter {
        padding: 0 10px;
        padding-bottom: 78px;

        .wzbj {
          display: block;
          .wzzs {
            width: 95vw;
            .searchbox {
              width: 80vw;
            }
            .appdsa {
              left: 65vw;
            }
            .sclb {
              width: 90vw;
            }
          }
        }

        .top {
          .top-Major {
            width: 95vw;
            flex-shrink: 0; /* 防止项目在空间不足时缩小 */
            white-space: nowrap; /* 确保项目不换行 */
            /* 样式调整，根据需要设置宽度、间距等 */
            margin-right: 10px;
            /* 其他样式 */
            overflow-x: auto;
          }
        }
        .Uploadarea {
          width: 95vw;
          .upload-demo {
            width: 90vw;
            ::v-deep .el-upload {
              width: 90vw;
              .el-upload-dragger {
                width: 90vw;
              }
            }
          }
        }
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 95vw;
    height: 363px;
    background: #f6f6f6;
    line-height: 363px;
    text-align: center;
  }
  .avatar {
    width: 95vw;
    height: 363px;
    background: #f6f6f6;
    display: block;
  }
  .nav-oad {
    display: flex;
    .nav-upload {
      width: 120px;
    }
    span {
      display: none;
    }
  }
  .Draftbox {
    flex-direction: column;
    display: block;
    width: 95vw;
    img {
      width: 246px;
      height: 150px;
      opacity: 0.8;
      border-radius: 6px;
    }
    .Draftbox_left {
      margin-top: 47px;
      width: 95vw;
      display: block;
      .certer {
        margin-left: 5px;
        ::v-deep .el-form-item {
          .el-form-item__content {
            width: 90vw;
          }
        }
      }
      .Draftbox_rist {
        width: 95vw;
      }
    }
  }

  .Draftbox_rist_bottom {
    width: 100%;
    margin-top: 10px;

    ::v-deep .el-form-item {
      .el-form-item__content {
        width: 90%;
      }
    }
  }
}
</style>
<style scoped>
.el-form-item >>> .el-form-item__content .el-textarea .el-textarea__inner {
  overflow: hidden;
  resize: none !important;
}
>>> .toolbar {
  border: 1px solid #ccc;
  flex-wrap: wrap;
}
</style>
